import { SHOW_NOTIFICATION, DISMISS_NOTIFICATION } from "../actionTypes";

const initialState = {
  message: null,
  type: null,
};

const notificationReducer = (state = initialState, action) => {
  switch (action.type) {
    case SHOW_NOTIFICATION:
      return {
        message: action.payload.message,
        type: action.payload.type || "error",
      };
    case DISMISS_NOTIFICATION:
      return initialState;
    default:
      return state;
  }
};

export default notificationReducer;
